export default function RangeSwitch({ value, onChange }) {
  return (
    <div className="range-switch" role="group" aria-label="统计范围">
      {[{ value: 1, label: '今天' }, { value: 7, label: '7 天' }, { value: 30, label: '30 天' }].map((option) => (
        <button key={option.value} type="button" className={value === option.value ? 'is-active' : ''} aria-pressed={value === option.value} onClick={() => onChange(option.value)}>
          {option.label}
        </button>
      ))}
    </div>
  );
}
